<div class="h-full si-card">
    <div class="border-b px-4 py-2 flex items-center justify-between">
        <h3 class="pt-2">Get More! Install RevDriver</h3>
        <a matButton="outlined" href="https://chromewebstore.google.com/detail/revdriver-by-salesintel/ngdjlkacliphopkcgcffflancnlbebnc?hl=en" class="mat-small-button card-btn" target="_blank">Install</a>
    </div>
    <div class="flex overflow-auto h-full w-full p-4 flex-wrap -mx-2 gap-0 items-center">
        <p class="empty-state-text text-secondary text-center">
            Bring SalesIntel with you to any domain, LinkedIn, LinkedIn SalesNavigator, and more! Get more done with the RevDriver Chrome extension.
        </p>
        <div class="text-center w-full">
            <img src="../../../../../../../assets/images/rev-driver.png" width="475" height="294" style="max-width: 100%;height: auto;width: 250px;"/>
        </div>
    </div>
</div>
